import { createAction } from '@reduxjs/toolkit';
import { createActionWithCallback } from 'core/store/utils';
import { RequestError, SituationForm } from 'types';

export const createSituation = createActionWithCallback<void, Error>()(
  'situation/create-situation',
  (situation: SituationForm) => ({
    payload: situation,
  })
);

export const createdSituation = createAction(
  'situation/created-situation',
  (data?: SituationForm, error?: RequestError) => ({
    payload: error || data,
    error: Boolean(error),
  })
);

export const updateSituation = createActionWithCallback<void, Error>()(
  'situation/update-situation',
  (situation: SituationForm) => ({
    payload: situation,
  })
);

export const updatedSituation = createAction(
  'situation/updated-situation',
  (data?: SituationForm, error?: RequestError) => ({
    payload: error || data,
    error: Boolean(error),
  })
);

export const deleteSituation = createAction('situation/delete-situation', (id: string) => ({
  payload: undefined,
  meta: { id },
}));

export const deletedSituation = createAction('situation/deleted-situation', (data?: boolean, error?: RequestError) => ({
  payload: error || data,
  error: Boolean(error),
}));

export default {
  createSituation,
  createdSituation,
  updateSituation,
  updatedSituation,
  deleteSituation,
  deletedSituation,
};
